'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NameDropdown = require('./components/NameDropdown.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NameDropdown).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/name-dropdown/index.js
// module id = 1048
// module chunks = 0